import * as S from "./style";
import axiosInstance from "../../services/axiosInstance";
import { useAuth } from "context/AuthContext";
//Components
import TitleDefault from "../../components/Title/TitleDefault";
import Footer from "../../components/Footer";
import { useEffect, useState } from "react";
import PopMenu from "../../components/PopMenuTable";
import Update from "../../components/Modals/User/Update";
import Details from "../../components/Modals/User/Details";
import Delete from "../../components/Modals/Delete";
import Loading from "../../components/Loading";
import useLoading from "../../hooks/useLoading";
import NoData from "../../components/NoData";
import Auth401 from "../../components/Error/Auth";
import Erro429 from "../../components/Error/Erro429";
//Icons
import { FiMoreVertical } from "react-icons/fi";
import { Trash, List, PencilSimple } from "@phosphor-icons/react";
//Hooks
import { useMultipleModal } from "../../hooks/useMultipleModal";
//Interface
import { IUser } from "Interfaces/IUser";
import { IPage } from "Interfaces/IPage";

export default function User() {

  const UserAuthenticated = useAuth();
  const isAdmin = UserAuthenticated.user?.email === 'admin@admin.com' ? true : false;

  const [data, setData] = useState<IUser[]>([]);
  const [openModalOptId, setOpenModalOptId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setCurrentPage] = useState<IPage>({
    id: 0,
    last_page: 0,
    current_page: 0,
    total: 0,
  });
  const { isOpenModal, toggleModalVisibility, assignRef } = useMultipleModal();
  const { isLoading, startLoading, stopLoading } = useLoading();

  const listHeaderTable = ["Nome", "E-mail", "Tipo", "Ações"];

  const menuItemsPop = [
    { icon: <List size={16} />, title: "Detalhes", isActive: false, path: "details" },
    { icon: <PencilSimple size={16} />, title: "Editar", isActive: false, path: "update" },
    { icon: <Trash size={16} />, title: "Excluir", isActive: true, path: "delete" },
  ];

  const handleMenuClick = (path: string) => {
    toggleModalVisibility(path);
  };

  const clickPopTable = (id: number) => {
    setOpenModalOptId(id);
    toggleModalVisibility("menu");
  };

  const handleSearchChange = (term: string) => {
    setSearchTerm(term);
    fetchData();
  };

  const fetchData = async (pageNumber = 1, perPage = 10) => {
    startLoading();
    try {
      let url = `/user?page=${pageNumber}&per_page=${perPage}`;
      if (searchTerm) {
        url += `&search=${searchTerm}`;
      }
      const response = await axiosInstance.get(url);
      const responseData = response.data.data;

      const filteredData = isAdmin
        ? responseData
        : responseData.filter((user: IUser) => user.email !== 'admin@admin.com');

      setData(filteredData);
      setCurrentPage(response.data);
      
    } catch (error: any) {
      if (error.status === 401) {
        toggleModalVisibility('auth');
      } else if (error.status === 429) {
        toggleModalVisibility('request429');
      }
      console.log("Error do User: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    const debounceFetch = setTimeout(() => {
      fetchData();
    }, 300);

    return () => clearTimeout(debounceFetch);
  }, [searchTerm]);

  if (isOpenModal("auth")) {
    return (
      <Auth401 isOpen={isOpenModal("auth")} />
    )
  } else if (isOpenModal("request429")) {
    return (
      <Erro429 />
    )
  }

  return (
    <S.Container>
      <TitleDefault
        filterSearch={handleSearchChange}
        modalKey="user"
        title="Registro de Usuários"
        subtitle="Gerencie os usuários do sistema"
        placeholderSearch="Nome do usuário"
        fetchData={fetchData}
        titleButton="Novo Usuário"
      />
      {isLoading ? (
        <Loading />
      ) : (
        <S.Content>
          <S.Table>
            <S.THead>
              <tr>
                {listHeaderTable.map((header, index) => (
                  <th key={index}>{header}</th>
                ))}
              </tr>
            </S.THead>

            <S.TBody>
              {
                data.length > 0 ? (
                  data.map((val, index) => (
                    <tr key={index}>
                      <td>{val.first_name}</td>
                      <td>{val.email || "-"}</td>
                      <td>
                        <div>
                          {val.is_admin === 1 && val.is_manager === 1 ? (
                            <>
                              <S.TypeUser>Admin</S.TypeUser>
                              <S.TypeUser>Gerente</S.TypeUser>
                            </>
                          ) : val.is_admin === 1 ? (
                            <S.TypeUser>Admin</S.TypeUser>
                          ) : val.is_manager === 1 ? (
                            <S.TypeUser>Gerente</S.TypeUser>
                          ) : (
                            <S.TypeUser>Atendente</S.TypeUser>
                          )}
                        </div>
                      </td>
                      <S.TdPopMenu>
                        <S.ContentPopMenu>
                          <S.ButtonTable onClick={() => clickPopTable(val.id)}>
                            <FiMoreVertical />
                          </S.ButtonTable>
                        </S.ContentPopMenu>
                        {isOpenModal("menu") && openModalOptId === val.id && (
                          <div ref={(ref) => assignRef("menu", ref)}>
                            <PopMenu menuItems={menuItemsPop} onClickTable={handleMenuClick} />
                          </div>
                        )}
                      </S.TdPopMenu>
                    </tr>
                  ))
                ) : <NoData />
              }
            </S.TBody>
          </S.Table>
        </S.Content>
      )}

      {page && (
        <Footer
          fetchData={fetchData}
          currentPage={page.current_page}
          lastPage={page.last_page}
          allPerPage={page.total}
        />
      )}

      <Update
        isOpenModal={isOpenModal("update")}
        setModalClose={() => toggleModalVisibility("update")}
        selectedUrlId={openModalOptId}
        updateList={fetchData}
      />

      <Details
        isOpenModalUser={isOpenModal("details")}
        setModalClose={() => toggleModalVisibility("details")}
        selectedUrlId={openModalOptId}
      />

      <Delete
        updateList={fetchData}
        endpoint="user"
        selectedProductId={openModalOptId}
        isOpenModal={isOpenModal("delete")}
        setModalClose={() => toggleModalVisibility("delete")}
      />
    </S.Container>
  );
}
